/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaHoodW36Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxSedonaHoodW36').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'VENT_HOOD_SVH36',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-hood-w-36.js.map